export class DemonstrativoDeResultado {

  Id: number;
  Codigo: number;
  CodigoCompleto: string;
  Descricao: string;
  GrupoId?: number;
  ReceitaDespesa: string;
  Formula: string;
  DemonstrativosDeResultado: DemonstrativoDeResultado[];
  Ativo: boolean;
  Gerencial: boolean;
  constructor() {
    this.GrupoId = null;
    this.ReceitaDespesa = 'R';
    this.Formula = '';
    this.Ativo = true;
    this.Gerencial = true;
  }
}
